import { Sector } from '@/domain/impact/impact.entity';
import { Co2Section } from '@/domain/impact-co2/entities/question.entity';
import { Co2QuizFormData } from '@/ui/pages/app/components/quiz-panel/co2/Co2QuizFormData';

export function getFestivalCo2QuizFormForSector(
  sector: Sector,
): Co2QuizFormData {
  return FORMS.filter((form) => form.sector === sector)[0];
}

export function getFestivalCo2QuizForms(): Co2QuizFormData[] {
  return FORMS;
}

const FORMS: Co2QuizFormData[] = [
  {
    sector: 'TEAM',
    sections: [
      {
        sectionKey: Co2Section.MOBILITY,
        questions: ['TEAM_MOBILITY'],
      },
      {
        sectionKey: Co2Section.CATERING,
        questions: ['CATERING_MEAL', 'CATERING_BEVERAGE'],
      },
      {
        sectionKey: Co2Section.ACCOMMODATION,
        questions: ['ACCOMMODATION'],
      },
    ],
  },
  {
    sector: 'ARTISTS',
    sections: [
      {
        sectionKey: Co2Section.MOBILITY,
        questions: ['MOBILITY'],
      },
      {
        sectionKey: Co2Section.CATERING,
        questions: ['CATERING_MEAL', 'CATERING_BEVERAGE'],
      },
      {
        sectionKey: Co2Section.ACCOMMODATION,
        questions: ['ACCOMMODATION'],
      },
      {
        sectionKey: Co2Section.CARGO,
        questions: ['CARGO'],
      },
    ],
  },
  {
    sector: 'PUBLIC',
    sections: [
      {
        sectionKey: Co2Section.MOBILITY,
        questions: ['MOBILITY'],
      },
      {
        sectionKey: Co2Section.CATERING,
        questions: ['CATERING_MEAL', 'CATERING_BEVERAGE'],
      },
      {
        sectionKey: Co2Section.ACCOMMODATION,
        questions: ['ACCOMMODATION'],
      },
      {
        sectionKey: Co2Section.DIGITAL,
        questions: ['DIGITAL'],
      },
    ],
  },
  {
    sector: 'SITE',
    sections: [
      {
        sectionKey: Co2Section.ENERGY,
        questions: ['ENERGY', 'GENERATOR'],
      },
      {
        sectionKey: Co2Section.WATER,
        questions: ['WATER'],
      },
      {
        sectionKey: Co2Section.WASTE,
        questions: ['RECYCLABLE_WASTE', 'NON_RECYCLABLE_WASTE'],
      },
      {
        sectionKey: Co2Section.EQUIPMENT,
        questions: ['EQUIPMENT'],
      },
      {
        sectionKey: Co2Section.CARGO,
        questions: ['CARGO'],
      },
      {
        sectionKey: Co2Section.BUILDING,
        questions: [
          'OFFICE_SUPPLIES_NEW',
          'OFFICE_SUPPLIES_REFURBISH',
          'BUILDING_HEATING',
          'BUILDING',
        ],
      },
    ],
  },
];
